import React from 'react'
import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  InputAdornment,
  OutlinedInput,
  TextField, Typography
} from "@mui/material";
import { useField } from 'formik';

const TextFieldWrapper = ({
  name,
  label,
  currency = false,
  ...otherProps
}) => {
  const [field, meta] = useField(name);

  const configTextField = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: 'outlined',
    size: 'small',
  }

  if (meta && meta.touched && meta.error) {
    configTextField.error = true;
    configTextField.helperText = meta.error;
  }

  return (
    <Grid
      item
      xs
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        marginTop: "16px",
      }}
    >
      <Typography variant="body1">{label}</Typography>
      {
        currency ?
          <FormControl {...configTextField}>
            <OutlinedInput
              name={name}
              style={{ fontSize: "19px", }}
              startAdornment={
                <InputAdornment
                  position="start"
                  sx={{ fontSize: "19px !important" }}
                >
                  ₦
                </InputAdornment>
              }
              // value={
              //   meta.value === ""
              //     ? ""
              //     : new Intl.NumberFormat().format(meta.value)
              // }
              // onChange={(event) => {
              //   const unformattedValue = event.target.value.replace(/,/g, "");
              //   field.onChange(unformattedValue)
              // }}
            />
            <FormHelperText>
              {meta.touched && meta.error}
            </FormHelperText>
          </FormControl>
          :
          <TextField {...configTextField} />


      }
    </Grid>
  )
}

export default TextFieldWrapper;